import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const TranscriptIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 22),
    viewBox: "0 0 22 22",
    ...svgProps,
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeWidth: "1.5",
    children: [/*#__PURE__*/jsx("path", {
      d: "m5.70588 1h-2.70588c-1.10457 0-2 .89543-2 2v2.44444"
    }), /*#__PURE__*/jsx("path", {
      d: "m1 16.5556v2.4444c0 1.1046.89543 2 2 2h2.70588"
    }), /*#__PURE__*/jsx("path", {
      d: "m16.2941 21h2.7059c1.1046 0 2-.8954 2-2v-2.4444"
    }), /*#__PURE__*/jsx("path", {
      d: "m21 5.44444v-2.44444c0-1.10457-.8954-2-2-2h-2.7059"
    }), /*#__PURE__*/jsx("path", {
      d: "m11.1619 7.30556v8.50004"
    }), /*#__PURE__*/jsx("path", {
      d: "m16.2942 8.77778v-2.22222h-10.58825v2.22222",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "m9.23535 16.5556h3.52945"
    })]
  });
};

export { TranscriptIcon };
//# sourceMappingURL=transcript.js.map
